export { default } from "./ReportTable";
export * from "./ReportTable";
